/* eslint-disable @typescript-eslint/no-explicit-any */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { AptIntel, MalwareIntel, NetworkIntel } from '../../types/StatTypes'

export interface AdversariesState {
  visualizationToShow: string
  malwareData: MalwareIntel | undefined
  aptData: AptIntel | undefined
  networkData: NetworkIntel | undefined
}

const initialState: AdversariesState = {
  visualizationToShow: 'networks',
  malwareData: undefined,
  aptData: undefined,
  networkData: undefined,
}

export const adversariesSlice = createSlice({
  name: 'adversaries',
  initialState,
  reducers: {
    setVisualizationToShow(state, action: PayloadAction<any>) {
      state.visualizationToShow = action.payload
    },
    setMalwareData(state, action: PayloadAction<any>) {
      state.malwareData = action.payload
    },
    setAptData(state, action: PayloadAction<any>) {
      state.aptData = action.payload
    },
    setNetworkData(state, action: PayloadAction<any>) {
      state.networkData = action.payload
    },
  },
})
export const selectAdversaries = (state: RootState) => state.adversaries

export const { setVisualizationToShow, setMalwareData, setAptData, setNetworkData } = adversariesSlice.actions
export default adversariesSlice.reducer
